const Rectangle: React.FC<{ className?: string }> = ({ className = '' }) => (
  <svg
    width='82'
    height='82'
    viewBox='0 0 82 82'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <rect
      x='41.12'
      y='-1.72571'
      width='60.6172'
      height='60.6172'
      rx='6'
      transform='rotate(45 41.12 -1.72571)'
      fill='#FC3C3C'
    />
  </svg>
)
type Props = {
  className?: string
}
export const Divider: React.FC<Props> = ({ className }) => (
  <div className={`flex items-center ${className}`}>
    <Rectangle className='h-3 w-3' />
    <Rectangle className='me-2 h-3 w-3' />
    <span className='bg-navy h-1 w-28 rounded-md'></span>
  </div>
)
